<template>
  <div class="form-field" :class="{ 'has-error': error }">
    <label class="form-field__label">
      <span>{{ label }}<span v-if="required" aria-hidden="true"> *</span></span>
      <slot />
    </label>
    <p v-if="helper && !error" class="form-field__helper">{{ helper }}</p>
    <p v-if="error" class="form-field__error" role="alert">{{ error }}</p>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  helper: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.form-field {
  display: grid;
  gap: var(--space-1);
}

.form-field__label {
  display: grid;
  gap: var(--space-2);
  color: var(--ink);
  font-size: 0.875rem;
  font-weight: 700;
}

.form-field__helper,
.form-field__error {
  margin: 0;
  font-size: 0.8125rem;
}

.form-field__helper {
  color: var(--ink-muted);
}

.form-field__error {
  color: var(--danger);
}

.has-error :deep(.ui-input),
.has-error :deep(.ui-select),
.has-error :deep(.ui-textarea) {
  border-color: var(--danger);
}
</style>
